module.exports = __webpack_public_path__ + "static/media/KollegeBackground.c95011a1.png";